<template>
  <div class="table-responsive full-height-tables" :class="{ border: loaded && nbResults }">
    <vcl-table v-if="!loaded" :rows="15" :columns="6"></vcl-table>
    <table
      v-else-if="loaded && nbResults"
      :class="[{ 'table-hover': tableHover, 'table-scroll': scrollable }, 'table table-md radius']"
    >
      <thead class="sticky-table" style="background-color: rgb(246, 246, 252)">
        <tr>
          <slot name="table-head"></slot>
        </tr>
      </thead>
      <tbody>
        <slot name="table-body"></slot>
      </tbody>
    </table>
    <b-row v-else class="justify-content-center margin-scroll">
      <h2>Aucun résultat 😥</h2>
    </b-row>
  </div>
</template>

<script>
import { VclTable } from 'vue-content-loading'

export default {
  name: 'tablee',
  components: {
    VclTable,
  },
  props: {
    tableHover: {
      type: Boolean,
      default: true,
    },
    loaded: {
      type: Boolean,
      default: true,
    },
    nbResults: {
      type: Number,
      default: -1,
    },
    scrollable: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>
.margin-scroll {
  margin-right: 10px;
}
table {
  border-spacing: 0;
  border-collapse: separate;
  border-radius: 10px;
}

table tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

table tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

table th:first-child,
table tr:first-child {
  border-top-left-radius: 10px;
}

table th:last-child,
table {
  border-top-right-radius: 10px;
}

.sticky-table {
  position: sticky;
  top: 0;
  z-index: 1;
}

.radius {
  border-color: transparent !important;
}
</style>
